module.exports = __webpack_public_path__ + "static/img/trial.1db7ebb8.svg";